var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期：",
      "label-width": "70px"
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.timedata,
      callback: function callback($$v) {
        _vm.timedata = $$v;
      },
      expression: "timedata"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "服务器列表："
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      multiple: true,
      all: ""
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", [[_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.queryEvent();
      }
    }
  }, [_vm._v("查询玩家等级停留")])]], 2)], 1)], 1), _c("vxe-table", {
    attrs: {
      id: "userLevelStayByCreateRoleTime",
      data: _vm.tableData,
      tableColumn: _vm.tableColumn
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };